import React from 'react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

export interface BreadcrumbItem {
  to?: string;
  title: React.ReactNode;
}

export interface BreadcrumbProps extends React.HTMLAttributes<HTMLDivElement> {
  items: BreadcrumbItem[];
  separator?: React.ReactNode;
}

const Breadcrumb = ({ className, items, separator = '/', ...props }: BreadcrumbProps) => {
  return (
    <nav className={cn('flex pl-4', className)} {...props}>
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <React.Fragment key={item.title as string}>
              <li className="flex items-center">
                {item.to && !isLast ? (
                  <Link
                    to={item.to}
                    className="text-sm font-medium text-primary transition-colors hover:text-primary/80"
                  >
                    {item.title}
                  </Link>
                ) : (
                  <span className={cn('text-sm font-medium', isLast ? 'text-primary-400' : 'text-gray-500')}>
                    {item.title}
                  </span>
                )}
              </li>
              {!isLast && (
                <li className="mx-1 text-gray-400" key={`separator-${index}`}>
                  {separator}
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export { Breadcrumb };
export default Breadcrumb;
